<template lang='pug'>
v-app(style='background: #FFFFFF !important;')
  v-container(fluid, grid-list-xl)
    v-content
      v-layout(row, justify-center)
        v-flex(xs12, sm12, md10, lg9, text-xs-center style="max-width: 1024px; margin: auto;")
          v-card(flat)
            breadcrumb(back='page3-3')
            v-card-text.label16tt.withDivider(style='margin-top:-58px;')
              | LECCIÓN: ELIGE TU CRÉDITO HIPOTECARIO
            v-card-text.titulo36Book
              |  ¡Quiero saber cómo me protege un Crédito Hipotecario!
            .video-responsive
              iframe(width="420" height="315" src="https://player.vimeo.com/video/287127139" frameborder="0" allowfullscreen)
            v-card-text.parrafoDestacado18.mx-0.px-0
              | Al contratar tu 
              b  Crédito Hipotecario adquieres cinco seguros que te protegen ante diversos imprevistos. 
              |  Es importante que identifiques qué cubre cada uno de ellos. 
              |  ¡Mira el siguiente video y siéntete seguro!
            v-btn.btn(justify-space-between, type='button', color='accent', @click.prevent="nextPage('page4-2')")
              | Siguiente
          l-progress(:value='this.$parent.currentPage')

</template>

<script>
import {
  eventBus
} from '../main';
export default {
  name: 'app',
  data() {
    return {
      progress: false,
      show: false
    }
  },
  created: function () {
    window.setInterval(() => {
        this.show = true;
    },300);
  },
  methods: {
    nextPage(page) {
      this.progress = true;
      eventBus.$emit('next_page', page);
    },
    nextChapter(page) {
      this.progress = true;
      eventBus.$emit('next_chapter', page);
    },
    lastChapter(page) {
      this.progress = true;
      eventBus.$emit('last_chapter', page);
    }
  },
};
</script>

<style lang="stylus">
.video-responsive
  overflow:hidden
  padding-bottom:56.25%
  position:relative
  height:0

.video-responsive iframe
  left:0
  top:0
  height:100%
  width:100%
  position:absolute

</style>